import api from '@/api'

export default {
  /* 精英机构全部数据统计 */
  getStatistics(){
    return api({
      url:'/statistics/statisticsInfo',
      method:'GET',
    })
  },

  /* 训练计划编写中， 训练计划待实施，训练计划已完成*/
  getStatisticsPlanList(){
    return api({
      url:'/statistics/statisticsPlanList',
      method:'GET',
    })
  },
  /* 精英机构数据统计 */
  getStatisticsClub(params){
    return api({
      url:'/statistics/statisticsClubInfo',
      method:'GET',
      params
    })
  },

  /* 训练计划编写中， 训练计划待实施，训练计划已完成*/
  getStatisticsClubPlanList(params){
    return api({
      url:'/statistics/statisticsClubPlanList',
      method:'GET',
      params
    })
  },
  /* 体教融合大数据 */
  getSchoolStatistics(){
    return api({
      url:'/statistics/statisticsSchoolInfo',
      method:'GET',
    })
  },
  /* 体教融合大数据 */
  getSchoolOrganizational(){
    return api({
      url:'/statistics/statisticsOrganizational',
      method:'GET',
    })
  },
  /* 基础设施大数据 */
  getSchoolSiteFacilities(){
    return api({
      url:'/statistics/statisticsSiteFacilities',
      method:'GET',
    })
  },
  /* 重点城市大数据 */
  getKeyCityTrainStatistics(){
    return api({
      url:'/statistics/keyCityTrainInfo',
      method:'GET',
    })
  },
}
